<template>
    <span class="info-tooltip">
        <img
            ref="tooltipButton"
            v-click-outside="hideTooltip"
            src="/images/map/information.svg"
            alt="Information"
            class="info-tooltip-icon"
            @click="toggleOpen"
        />

        <teleport
            v-if="showTooltip"
            to="body"
        >
            <div
                class="tooltip"
                :style="tooltipStyles"
            >
                <p class="tooltip__body">
                    <slot></slot>
                </p>
            </div>
        </teleport>
    </span>
</template>

<script>
export default {
    data() {
        return {
            showTooltip: false,
            tooltipStyles: {},
        }
    },

    methods: {
        toggleOpen(e) {
            if (!this.showTooltip) {
                document.body.click()
            }
            e.stopPropagation()
            this.showTooltip = !this.showTooltip
            if (this.showTooltip) {
                this.repositionTooltip()
            }
        },

        hideTooltip() {
            this.showTooltip = false
        },

        repositionTooltip() {
            this.$nextTick(() => {
                const button = this.$refs.tooltipButton.getBoundingClientRect()
                this.tooltipStyles = {
                    top: `${button.bottom + window.scrollY}px`,
                    left: `${button.left + window.scrollX + button.width / 2}px`,
                    transform: 'translateX(-50%)',
                    zIndex: 5000,
                }
            })
        },
    },
}
</script>

<style scoped>
.info-tooltip {
    position: relative;
}

.info-tooltip-icon {
    cursor: pointer;
    margin-left: 5px;
}

.tooltip {
    cursor: default;
    z-index: 4000;
    width: 132px;
    padding: 6px 8px;
    background-color: rgba(97, 97, 97, 0.9);
    border-radius: 2px;
    top: 0;
    left: 0;
    transform: translate3d(-57px, 18px, 0px);
    position: absolute;
}

.tooltip__body {
    text-align: center;
    font-family: 'Avenir Book';
    font-size: 12px;
    line-height: 16px;
    color: #fff;
}
</style>
